import {Component} from "react"
import getMessage from "../getMessage"
import FormatMessage from "../../types/FormatMessage"

interface Props {
  formatMessage: FormatMessage
}

/**
 * @description: A helper to resolve either a language key or an already translated string.
 * Useful for resolving defaultProps
 */
export default (component: Component<Props>, key: string, object: any = component.props, values: any = {}) => {
  const {formatMessage} = component.props
  return getMessage(formatMessage, object[key], values)
}
